// extracted by mini-css-extract-plugin
module.exports = {"side_filter":"SideFilter_side_filter__3ZIR2","open":"SideFilter_open__2KpZE","open_filter":"SideFilter_open_filter__Qicog"};